import { produce } from "immer";
import AuditlogEventTypeSelector from "./AuditlogEventTypeSelector";
import UtilService from "../../service/UtilService";

const AuditlogFilter = ({ filterConfig, onChange }) => {
  return (
    <table className="config-table">
      <thead>
        <tr>
          <th>Filter</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Date-time range [min - max UTC]</td>
          <td>
            <input
              type="datetime-local"
              value={filterConfig.createdMin || ""}
              onChange={(e) =>
                onChange(
                  produce(filterConfig, (d) => {
                    d.createdMin = e.target.value;
                  }),
                )
              }
            />
            &nbsp;-&nbsp;
            <input
              type="datetime-local"
              value={filterConfig.createdMax || ""}
              onChange={(e) =>
                onChange(
                  produce(filterConfig, (d) => {
                    d.createdMax = e.target.value;
                  }),
                )
              }
            />
          </td>
        </tr>

        <tr>
          <td>User ID (include)</td>
          <td>
            <input
              type="text"
              placeholder="e.g., admin@eurowag.com"
              value={filterConfig.userId || ""}
              onChange={(e) =>
                onChange(
                  produce(filterConfig, (d) => {
                    d.userId = e.target.value;
                  }),
                )
              }
            />
          </td>
        </tr>

        <tr>
          <td>Exclude User IDs</td>
          <td>
            <input
              type="text"
              placeholder="Comma-separated, e.g., PABLO,system"
              value={UtilService.arrayToCsv(filterConfig.excludeUserIds || [])}
              onChange={(e) =>
                onChange(
                  produce(filterConfig, (d) => {
                    d.excludeUserIds = UtilService.csvToStringArray(
                      e.target.value,
                    );
                  }),
                )
              }
            />
          </td>
        </tr>

        <tr>
          <td>Event Types</td>
          <td>
            <AuditlogEventTypeSelector
              selected={filterConfig.eventTypes || []}
              onChange={(newEventTypes) =>
                onChange(
                  produce(filterConfig, (d) => {
                    d.eventTypes = newEventTypes;
                  }),
                )
              }
            />
          </td>
        </tr>

        <tr>
          <td>Page size</td>
          <td>
            <input
              type="number"
              min={10}
              max={200}
              value={filterConfig.pageSize ?? ''}
              placeholder="30"
              onChange={(e) => {
                const val = e.target.value;
                onChange(
                  produce(filterConfig, (d) => {
                    d.pageSize = val === '' ? null : Number(val);
                  }),
                );
              }}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default AuditlogFilter;
